import { postRegister } from "../../../helpers/promedico_api_helper";
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
} from "./reducer";

export const registerUser = (user: any) => async (dispatch: any) => {
  try {
    const response: any = await postRegister({
      name: user.first_name,
      email: user.email,
      password: user.password
    });

    if (response && response.token) {
      const successData: any = {
        message: "success",
        token: response.token,
        user: response.user
      };

      dispatch(registerUserSuccessful(successData));
    } else {
      dispatch(registerUserFailed({ message: "Registration failed" } as any));
    }
  } catch (error: any) {
    dispatch(registerUserFailed({ message: error || "Registration failed" } as any));
  }
};

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};
